module.exports = __webpack_public_path__ + "static/media/SL.e0f24176.png";